const Footer = () => {
  return (
   <div
     className=" w-100 d-flex justify-content-between align-items-center px-4 py-2"
     style={{ backgroundColor: "#f2f4f9" }}
    >
     <div>© Disha 2026</div>
     <div>
        Powered by{" "}
        <a
         href="https://www.evvotechnology.com/"
         target="_blank"
         style={{ textDecoration: "none", color: "black" }}
        >
         Evvo Technology
        </a>
     </div>
    </div>
  );
};

export default Footer;
